import { styled } from '@mui/material/styles'
import {
  Typography,
  TypographyProps,
  ListItem,
  ListItemProps
} from '@mui/material'

export const SemPlataformas = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    ...theme.typography.caption,
    color: theme.palette.text.terciary,
    fontSize: 10,
    fontStyle: 'italic'
  })
)

export const ItemLista = styled(ListItem)<ListItemProps>(() => ({
  height: 48,
  display: 'flex'
}))
